(ns hai.ui.components.read-only-cue
  "The one-line cue an entity's page shows a viewer who cannot edit it. The page
   is otherwise just missing its controls, so this says why.

   Takes its words from the caller rather than naming the entity itself: what is
   true varies with what the viewer *can* still do — a viewer with delete but not
   update rights is not looking at something read-only."
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled cue :span
  ;; `inline-flex` alone is inert on a flex child — the parent blockifies it and
  ;; stretches it the width of the column. `align-self` keeps it hugging its text
  ;; whatever the host lays it out with.
  {:display "inline-flex" :align-items "center" :gap "6px"
   :align-self "flex-start"
   :font-size "13px" :font-style "italic"
   :color t/--card-warning-text}
  [:svg {:width "15px" :height "15px" :fill "currentColor"}]
  ([& children]
   ;; Never a bare `:<>` first child — Ornament recurses into a leading fragment
   ;; and drops its siblings.
   (into [:<> [icons/outlined-lock]] children)))
